define( function() {
	"use strict";

	return ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/pnum.js
// module id = 445
// module chunks = 17 22 23